"use client";

import { useGlobal } from "@/features/global/GlobalContext";
import styles from "./TextImage.module.css";
import type { ReactNode } from "react";

interface TextImageColorWrapProps {
	backgroundColor?: string | number;
	reversed?: boolean;
	children: ReactNode;
}

export const TextImageColorWrap = ({ backgroundColor, reversed, children }: TextImageColorWrapProps) => {
	const {
		data: { colorMap },
	} = useGlobal();

	const colorEntry = colorMap[String(backgroundColor!)] || "";

	return (
		<div
			className={styles.text}
			data-reversed={reversed}
			style={{
				backgroundColor: colorEntry.color,
				color: colorEntry.foreground,
			}}
		>
			{children}
		</div>
	);
};
